import { createContext } from 'react';

/** Mobile drawer toggle from Authenticated; must not be passed to DOM nodes (e.g. MUI Box). */
export const AuthenticatedMenuContext = createContext(() => {});
